import { render, staticRenderFns } from "./shop-products.vue?vue&type=template&id=4bcf8876&"
import script from "./shop-products.vue?vue&type=script&lang=js&"
export * from "./shop-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports